
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	

	// $('.csv-slick-1').slick({
	// 	dots: true,
	// 	speed: 300,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	// 	focusOnSelect: true,
	//     autoplaySpeed: 6000,
	//     // asNavFor: '.lsi-property-slick-nav',
	// });
	// 
	
	

	// $('.csv-slick-2').slick({
	// 	dots: true,
	// 	speed: 600,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	centerPadding: 0,
	// 	arrows: true,
	// 	focusOnSelect: true,
	//     autoplaySpeed: 3000,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	//     responsive: [
	// 				    {
	// 				      	breakpoint: 991,
	// 				      	settings: {
	// 				        	slidesToShow: 2,
	// 				      	}
	// 				    },
	// 				    {
	// 				      	breakpoint: 500,
	// 				      	settings: {
	// 				        	slidesToShow: 1,
	// 				      	}
	// 				    },
	//     			]
	// });


	$('.csv-highlight-section.-slick').slick({
		dots: false,
		speed: 600,
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
					    // {
					    //   	breakpoint: 500,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
	    			]
	});


	$('.csv-group-home-list').slick({
		dots: true,
		speed: 600,
		infinite: true,
		autoplay: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 5000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 1,
					      	}
					    },
	    			]
	});


	$('.csv-assessments-list').slick({
		dots: true,
		speed: 600,
		infinite: true,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 12000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev  icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next  icon-arrow-s-r"></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
					    // {
					    //   	breakpoint: 500,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
	    			]
	});


	$('.csv-brands-list:not(.-list-v2)').slick({
		dots: false,
		speed: 600,
		infinite: true,
		autoplay: true,
		slidesToShow: 6,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 2500,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev  icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next  icon-arrow-s-r"></span>',
	    responsive: [
					    {
					      	breakpoint: 991,
					      	settings: {
					        	slidesToShow: 4,
					      	}
					    },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 2,
					      	}
					    },
	    			]
	});

	$('.csv-brands-list.-list-v2').slick({
		dots: false,
		speed: 600,
		infinite: true,
		autoplay: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 2500,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev  icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next  icon-arrow-s-r"></span>',
	    responsive: [
					    /*{
					      	breakpoint: 991,
					      	settings: {
					        	slidesToShow: 5,
					      	}
					    },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 3,
					      	}
					    },*/
	    			]
	});


	$('.csv-services-cards.-slick').slick({
		dots: false,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 3,
		// slidesToScroll: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 8000,
		prevArrow: '<span class="slick-prev  icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next  icon-arrow-s-r"></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 2,
					    //   	}
					    // },
					    {
					      	breakpoint: 767,
					      	settings: {
					        	slidesToShow: 1,
								// slidesToScroll: 1,
								slidesToScroll: 1,
					      	}
					    },
	    			]
	});


	$('.csv-banner-slick').slick({
		dots: true,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 1,
		// slidesToScroll: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 6000,
		prevArrow: '<span class="slick-prev  icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next  icon-arrow-s-r"></span>',
	});


	$('.csv-solutions-cards.-slick').slick({
		// dots: false,
		dots: true,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 3,
		// slidesToScroll: 1,
		slidesToScroll: 3,
		centerMode: false,
		centerPadding: 0,
		// arrows: true,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 4,
					    //   	}
					    // },
					    {
					      	breakpoint: 767,
					      	settings: {
					        	slidesToShow: 1,
								// slidesToScroll: 1,
								slidesToScroll: 1,
					      	}
					    },
	    			]
	});


	$('.csv-cases-cards.-slick').slick({
		// dots: false,
		dots: true,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 3,
		// slidesToScroll: 1,
		slidesToScroll: 3,
		centerMode: false,
		centerPadding: 0,
		// arrows: true,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 4,
					    //   	}
					    // },
					    {
					      	breakpoint: 767,
					      	settings: {
					        	slidesToShow: 1,
								// slidesToScroll: 1,
								slidesToScroll: 1,
					      	}
					    },
	    			]
	});


	$('.csv-areas-cards.-slick').slick({
		// dots: false,
		dots: true,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 4,
		// slidesToScroll: 1,
		slidesToScroll: 4,
		centerMode: false,
		centerPadding: 0,
		// arrows: true,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 4000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 4,
					    //   	}
					    // },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 2,
								// slidesToScroll: 1,
								slidesToScroll: 2,
					      	}
					    },
	    			]
	});




	





	window.addEventListener('resize', function(event){



	});
	

    
}(window.jQuery, window, document));